export enum CompanyStatus {
  Suspended,
  Active,
}
